// WelcomeMessage.js
import React, { useEffect, useState } from 'react';
import './WelcomeMessage.css';

const WelcomeMessage = () => {
    const [showWelcome, setShowWelcome] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
          setShowWelcome(false);
        }, 500000000);
    
        return () => {
          clearTimeout(timer);
        };
      }, []);

    return (
        <>
            {showWelcome && (
                <div className="welcome-container">
                    <div className="welcome-message">
                        <p>Welcome to</p>
                        <h1 className="app-name">Pixabay</h1>
                        <p>Created with passion by</p>
                        <h1 className='created-by'>Rakesh Yadav</h1>
                        <div className="circle-animation"></div>
                    </div>
                </div>
            )}
        </>
    );
};

export default WelcomeMessage;
